import { render } from "./Piano.vue?vue&type=template&id=56dc8495&scoped=true"
import script from "./Piano.vue?vue&type=script&lang=js"
export * from "./Piano.vue?vue&type=script&lang=js"

import "./Piano.vue?vue&type=style&index=0&id=56dc8495&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src748492411/src/personal-webpage-vue-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56dc8495"]])

export default __exports__